import {
  queryOptions,
  useMutation,
  useQueryClient
} from '@tanstack/react-query';

import API from '@api';

/** Подписка «сообщить о поступлении товара» */
export const CHECK_PEOPLE_SUBSCRIPTION_QUERY_KEY = 'checkPeopleSubscription';

export const checkPeopleSubscriptionQueryOptions = (
  productId: number,
  subscription_type: string
) =>
  queryOptions({
    queryKey: [
      CHECK_PEOPLE_SUBSCRIPTION_QUERY_KEY,
      productId,
      subscription_type
    ],
    queryFn: () =>
      API.checkPeopleSubscription({ productId, subscription_type }),
    select: res => ({
      sms: !!res?.checkPeopleSubscription?.peopleSubscription?.existing?.sms,
      email: !!res?.checkPeopleSubscription?.peopleSubscription?.existing?.email
    })
  });

/**
 * Подписка «сообщить о поступлении»: при успехе инвалидируются проверки
 * существующих подписок — кнопки «Вы уже подписаны» обновляются сами.
 */
/**
 * Подтверждение подписки на рассылку по ссылке из письма (/subscribe/:hash).
 * One-shot запрос с побочным эффектом на сервере — по сути мутация,
 * кэшировать нечего.
 */
export const useConfirmSubscribeMutation = () =>
  useMutation({
    mutationFn: (variables: Parameters<typeof API.confirmSubscribe>[0]) =>
      API.confirmSubscribe(variables)
  });

export const useProductSubscribeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof API.productSubscribe>[0]) =>
      API.productSubscribe(variables),
    onSuccess: res => {
      if (res?.productSubscribe.result) {
        void queryClient.invalidateQueries({
          queryKey: [CHECK_PEOPLE_SUBSCRIPTION_QUERY_KEY]
        });
      }
    }
  });
};
